import React, { JSX, ReactNode } from 'react'
import { Link } from 'react-router'
import { CONNECTIONS_PATH } from 'lib/paths'
import { ProviderBrandIcon, YOUTUBE_BRAND_ICON_SRC } from 'components/ProviderBrandIcon'

export const YOUTUBE_AREA_ANCHOR_ID = 'youtube'
export const YOUTUBE_AREA_LINK_LABEL = 'Open YouTube on the Connections page in a new tab'
export const YOUTUBE_AREA_ANCHOR_LABEL = 'Go to the YouTube card on this page'

const FOCUS_RING = 'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand'

export const YouTubeAreaLink = ({
  onAreaPage = false,
  corners = 'rounded',
  children
}: {
  onAreaPage?: boolean
  corners?: 'rounded' | 'rounded-lg'
  children: ReactNode
}): JSX.Element => (
  <Link
    to={{ pathname: CONNECTIONS_PATH, hash: `#${YOUTUBE_AREA_ANCHOR_ID}` }}
    target={onAreaPage ? undefined : '_blank'}
    rel={onAreaPage ? undefined : 'noopener noreferrer'}
    aria-label={onAreaPage ? YOUTUBE_AREA_ANCHOR_LABEL : YOUTUBE_AREA_LINK_LABEL}
    title={onAreaPage ? YOUTUBE_AREA_ANCHOR_LABEL : YOUTUBE_AREA_LINK_LABEL}
    data-testid='youtube-area-link'
    className={`inline-flex shrink-0 ${corners} ${FOCUS_RING}`}
  >
    {children}
  </Link>
)

export const YouTubeAreaIconLink = ({
  size = 'sm',
  onAreaPage = false
}: {
  size?: 'md' | 'sm'
  onAreaPage?: boolean
}): JSX.Element => (
  <YouTubeAreaLink onAreaPage={onAreaPage} corners={size === 'md' ? 'rounded-lg' : 'rounded'}>
    <ProviderBrandIcon src={YOUTUBE_BRAND_ICON_SRC} size={size} />
  </YouTubeAreaLink>
)
